import { render, staticRenderFns } from "./NewMainHeader.vue?vue&type=template&id=505d9c1a&scoped=true"
import script from "./NewMainHeader.vue?vue&type=script&lang=js"
export * from "./NewMainHeader.vue?vue&type=script&lang=js"
import style0 from "./NewMainHeader.vue?vue&type=style&index=0&id=505d9c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d9c1a",
  null
  
)

export default component.exports